// Maps posts that review a single, identifiable software product to a
// schema.org SoftwareApplication entity. Only these posts should emit
// review / aggregateRating markup — Google's Review snippet does not
// support the Article type.

export interface ReviewedProduct {
  name: string;
  applicationCategory: string; // schema.org/SoftwareApplicationCategory
  operatingSystem?: string;
  url?: string;
}

export const reviewedProductByPostId: Record<number, ReviewedProduct> = {
  5: {
    name: "HubSpot",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://www.hubspot.com",
  },
  7: {
    name: "Zoho CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://www.zoho.com/crm/",
  },
  9: {
    name: "monday sales CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://monday.com/crm",
  },
  10: {
    name: "Freshsales",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://www.freshworks.com/crm/sales/",
  },
  11: {
    name: "Close CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://close.com",
  },
  12: {
    name: "Salesforce Starter Suite",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://www.salesforce.com/sales/starter/",
  },
  14: {
    name: "Acumatica Cloud ERP",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    url: "https://www.acumatica.com",
  },
};

export function getReviewedProduct(postId: number): ReviewedProduct | undefined {
  return reviewedProductByPostId[postId];
}
